import { combineReducers } from "redux";

import {
    SET_BUSINESSES,
    CURRENT_BUSINESS
} from '../constants/actionTypes';

const initState = {
    businesses: null,
    curBusiness: null
}

function businesses(state = initState.businesses, action) {
    switch(action.type) {
        case SET_BUSINESSES:
            return action.choices
        default:
            return state;
    }
}

function curBusiness(state = initState.curBusiness, action) {
    switch(action.type) {
        case CURRENT_BUSINESS:
            return action.business
        default:
            return state;
    }
}

export default combineReducers({
    businesses,
    curBusiness
})